const formControlLabelModalPlace = {
  business: 'Ramo',
  room: 'Folha'
};

export default formControlLabelModalPlace;
